import PropTypes from 'prop-types';
import deprecatedProp from '../utils/deprecated_prop';
import { popoverPlacements } from '../shared/popover/prop_types';
var optionPropTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
var propTypes = {
  anchorNode: PropTypes.node,
  anchorReference: PropTypes.oneOf(['children', 'position']),
  children: PropTypes.node,
  className: PropTypes.string,
  defaultOpen: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  /** @deprecated */
  onMouseDown: deprecatedProp(PropTypes.func, "Use `onClick` function instead of `onMouseDown` to get the clicked option.\n    If you're using the callback only to get the event object, disregard this warning message."),
  open: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape(optionPropTypes).isRequired),
  placement: PropTypes.oneOf(popoverPlacements),
  portal: PropTypes.bool,
  position: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }),
  role: PropTypes.string,
  selectedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  useJsPositioning: PropTypes.bool
};
export default propTypes;